import $ from 'jquery';

var pos = 0;

$(window).resize(function () {
  copyCatHeight();
  scrollHomepage();
  //  moveInteractionsWrapper();
  collapseHomepage();
});

$(window).scroll(function () {
  scrollHomepage();

  var slideUp = $('#slide-up');

  if ($(this).scrollTop() > 0) {
    slideUp.fadeIn();
  } else {
    slideUp.fadeOut();
  }


});

$(document).ready(function () {
  //Give container to wp-block-columns dashboard elements
  var wpBlockColumns = $('.wp-block-columns');
  if (wpBlockColumns.length > 0) {
    wpBlockColumns.addClass('container wp-columns-customs');
  }

  $(".btn-close").click(function () {
    var t = $(this).data('target');
    $(t).slideToggle();
  });

  var autoShowMore = $('.auto-show-more');
  var smCount = 1;
  autoShowMore.each(function () {
    $(this).addClass("auto-show-more-hide auto-show-more-sm" + smCount);
    $(this).after('<div class="auto-show-more-toggle-wrapper auto-show-more-toggle-wrapper-sm' + smCount + ' "><a class="auto-show-more-toggle btn btn-primary ' + "toggle-sm" + smCount + ' "  data-target="' + smCount + '" href="#">+</a></div>');
    smCount++;
  });

  var autoShowMoreToggle = $('.auto-show-more-toggle');
  autoShowMoreToggle.on('click', function (event) {
    event.preventDefault();
    var smt = $(this).data('target');
    $(".auto-show-more-sm" + smt).toggleClass("auto-show-more-show");
    $(".auto-show-more-toggle-wrapper-sm" + smt).remove();
  });

  // Click disappear
  $(".click-disappear").click(function () {
    $(this).removeClass();
    $(this).addClass('d-none mt-0 mb-0');
  });

  $('.file-group-switch').click(function() {
    // Ajoute la classe "current" à l'élément cliqué
    $(this).addClass('current');
    
    // Retire la classe "current" des autres éléments du groupe "file-group-switch"
    $('.file-group-switch').not(this).removeClass('current');
    
    // Récupère la valeur de l'attribut "target-class"
    var toActive = $(this).data('target-class');

    // Retire la classe "active" de tous les éléments du groupe "file-group"
    $('.file-group').removeClass('active');

    // Applique la classe "active" aux éléments du groupe "file-group" qui ont la classe "target-class"
    $('.file-group.' + toActive).addClass('active');
  });

  $('a.clink').click(function(e) {
    var href = $(this).attr('href');
    if (href.startsWith('#')) {
      e.preventDefault();
      var targetId = href.substring(1);
      var targetOffset = $('#' + targetId).offset().top - 150;
      $('html, body').animate({ scrollTop: targetOffset }, 500);
    }
  });

  // // /********* STICKY MENU **********/
  /*
  $(window).scroll(function(){

    if ($(this).scrollTop() > 0) {
      $('#main-header').addClass("scrolled");
      $('#home-scroll-indicator').css('opacity',0);
      if ($("#picto-scroller").length > 0) {
        $('#picto-scroller').removeClass('active');
      }
    }else{
      $('#main-header').removeClass("scrolled");
      $('#home-scroll-indicator').css('opacity',1);
      if ($("#picto-scroller").length > 0) {
        $('#picto-scroller').addClass('active');
      }
    }
  });
  */
  /* *************************************** */

  var slideUp = $('#slide-up');
  slideUp.click(function () {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  });
  if ($(window).scrollTop() == 0) {
    slideUp.fadeOut();
  }

  copyCatHeight();
  scrollHomepage();
  collapseHomepage();
  maxHeightBlockDuo();
});

$(window).on('resize', function () {
  maxHeightBlockDuo();
});

function maxHeightBlockDuo() {
  /*
  var picBlocks = $('.block-duo .picture-wrapper');
  picBlocks.each(function () {
    $(this).css('max-height', ""); //reset max-height
    var oH = $(this).outerHeight();
    $(this).css('max-height', oH);
  });
  */
}

function moveInteractionsWrapper() {
  var navWrapperE = $('#main-header #main-navigation-wrapper-e');
  var rowInteractions = $('#main-header .row-interactions');
  var calc = (navWrapperE.offset().left + navWrapperE.outerWidth() - rowInteractions.outerWidth());
  rowInteractions.offset({ left: calc });
  rowInteractions.css('opacity', 1);
}

function scrollHomepage() {
  if ($(window).scrollTop() > 0) {
    $('#main-header').addClass("scrolled");
    $('#home-scroll-indicator').css('opacity', 0);
    if ($("#picto-scroller").length > 0) {
      $('#picto-scroller').removeClass('active');
    }
  } else {
    $('#main-header').removeClass("scrolled");
    $('#home-scroll-indicator').css('opacity', 1);
    if ($("#picto-scroller").length > 0) {
      $('#picto-scroller').addClass('active');
    }
  }

  //  moveInteractionsWrapper();
}

function collapseHomepage() {
  var element = $("#homepage #mainContentPresentationBis");
  if ($(element).length > 0) {
    if ($(window).width() < 768) {
      element.addClass('collapse');
    }
  }
}

function copyCatHeight() {
  var elems = $('.copy-cat');
  if ($(elems).length > 0) {
    $(elems).each(function () {
      var cTarget = $(this).data('copy-target');
      $(this).css('height', $(cTarget).outerHeight() + "px");
    });
  }
}
